function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';
import lowerCase from 'lodash/lowerCase';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import AddIcon from 'svg/add.svg';
import RemoveIcon from 'svg/remove.svg';
import Loupe from 'svg/loupe-light.svg';
import Input from 'components/Form/Input';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import StandardActions from 'components/Form/StadardActions';
import FormContainerAbstract from 'components/FormContainerAbstract';
import App from 'modules/App';
import Table from 'components/Table';
import * as actions from '../../../../actions';
import * as selectors from '../../../../selectors';
import messages from '../../../../messages';
import * as constants from '../../../../constants';
import validatorRules from './validatorRules.json';
import styles from './Meters.pcss';
class MetersForm extends FormContainerAbstract {
    componentDidUpdate(prevProps, prevState) {
        if (prevState.assignedMeters.length !== this.state.assignedMeters.length || prevState.unassignedMeters.length !== this.state.unassignedMeters.length) {
            this.setFormStatus();
        }
        if (prevState.search !== this.state.search) {
            this.onSearchFinish();
        }
        if (prevProps.isUpdateInProgress && !this.props.isUpdateInProgress) {
            this.onSetShouldReset();
        }
        if (this.state.shouldReset && !this.props.isFetchInProgress) {
            this.onInitialize();
        }
    }
    onInitialize() {
        this.setState({
            formInitialState: JSON.parse(JSON.stringify({
                assignedMeters: this.props.assignedMeters,
                unassignedMeters: this.props.unassignedMeters
            })),
            hasUnsavedChanges: false,
            assignedMeters: [
                ...this.props.assignedMeters
            ] || [],
            unassignedMeters: [
                ...this.props.unassignedMeters
            ] || [],
            shouldReset: false,
            isSearchProcessing: false
        });
    }
    onSetShouldReset() {
        this.setState({
            shouldReset: true
        });
    }
    onSubmit() {
        const devices = (this.state.assignedMeters || []).map((x)=>x.sku);
        this.props.onSubmit({
            devices
        });
    }
    onSearchFinish() {
        this.setState((state)=>({
                isSearchProcessing: state.isSearchProcessing
            }));
    }
    onReset() {
        this.setState({
            assignedMeters: [
                ...this.state.formInitialState.assignedMeters
            ],
            unassignedMeters: [
                ...this.state.formInitialState.unassignedMeters
            ],
            hasUnsavedChanges: false
        });
        this.props.onFormErrors(null);
    }
    setFormStatus() {
        const hasUnsavedChanges = !isEqual(this.state.formInitialState.assignedMeters, this.state.assignedMeters) || !isEqual(this.state.formInitialState.unassignedMeters.map((x)=>x.sku).sort(), this.state.unassignedMeters.map((x)=>x.sku).sort());
        this.setState({
            hasUnsavedChanges
        });
        this.props.onHasUnsavedChangesChanged(hasUnsavedChanges);
    }
    get baseSchema() {
        return [
            {
                key: 'name',
                labelMessage: messages.labels.meterName,
                renderer: (meter)=>/*#__PURE__*/ _jsx("b", {
                        children: meter.name
                    })
            },
            {
                key: 'sku',
                labelMessage: messages.labels.metersSku,
                renderer: (meter)=>/*#__PURE__*/ _jsx("p", {
                        children: meter.sku
                    })
            }
        ];
    }
    get assignedSchema() {
        return [
            ...this.baseSchema,
            {
                key: 'action',
                renderer: (meter)=>this.renderUnassignAction(meter)
            }
        ];
    }
    get unassignedSchema() {
        return [
            ...this.baseSchema,
            {
                key: 'action',
                renderer: (meter)=>this.renderAssignAction(meter)
            }
        ];
    }
    get filteredAssignedEntities() {
        const entities = this.state.search ? this.filterEntities(this.state.assignedMeters, this.state.search) : this.state.assignedMeters;
        return this.orderSearch(entities);
    }
    get filteredUnassignedEntities() {
        const entities = this.state.search ? this.filterEntities(this.state.unassignedMeters, this.state.search) : this.state.unassignedMeters;
        return this.orderSearch(entities);
    }
    onAssignMeter(meter) {
        this.setState((state)=>{
            const unassignedMeters = filter(this.state.unassignedMeters, (unassignedMeter)=>unassignedMeter.sku !== meter.sku);
            return {
                assignedMeters: [
                    ...state.assignedMeters,
                    meter
                ],
                unassignedMeters
            };
        });
    }
    onUnassignMeter(meter) {
        this.setState((state)=>{
            const assignedMeters = filter(this.state.assignedMeters, (unassignedMeter)=>unassignedMeter.sku !== meter.sku);
            return {
                assignedMeters,
                unassignedMeters: [
                    ...state.unassignedMeters,
                    meter
                ]
            };
        });
    }
    filterEntities(entities, searchValue) {
        const value = lowerCase(searchValue);
        return filter(entities, (entity)=>lowerCase(entity.name).includes(value) || lowerCase(entity.sku).includes(value));
    }
    orderSearch(entities) {
        return entities.sort((a, b)=>{
            if (lowerCase(a.name) > lowerCase(b.name)) {
                return 1;
            }
            if (lowerCase(a.name) < lowerCase(b.name)) {
                return -1;
            }
            return -1;
        });
    }
    renderAssignAction(meter) {
        return /*#__PURE__*/ _jsx(Button, {
            className: cn(styles.table__cell__actionButton, 'btn--primary', 'btn--filled'),
            onClick: ()=>this.onAssignMeter(meter),
            children: /*#__PURE__*/ _jsx(AddIcon, {})
        });
    }
    renderUnassignAction(meter) {
        return /*#__PURE__*/ _jsx(Button, {
            className: cn(styles.table__cell__actionButton, 'btn--filled'),
            onClick: ()=>this.onUnassignMeter(meter),
            children: /*#__PURE__*/ _jsx(RemoveIcon, {})
        });
    }
    renderSearch() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header__search,
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.searchMeters,
                    value: this.state.search,
                    onChange: (input)=>this.setState({
                            isSearchProcessing: true,
                            search: input.value
                        })
                }),
                /*#__PURE__*/ _jsx(Loupe, {
                    className: styles.search__loupe
                })
            ]
        });
    }
    renderAssignedTable() {
        const b = (chunks)=>/*#__PURE__*/ _jsx("b", {
                children: chunks
            });
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.table, styles.table__assigned),
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h5 mt-0",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.metersAssignedToCountry))
                }),
                this.state.assignedMeters.length ? /*#__PURE__*/ _jsx(Table, {
                    idKey: "deviceId",
                    schema: this.assignedSchema,
                    entities: this.filteredAssignedEntities || [],
                    perPage: 10,
                    isPerPageOff: true
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--paragraph",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.noneMetersAssignedToCountry), {
                                values: {
                                    b
                                }
                            }))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--paragraph mt-7",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.emptyCountryWillAssignAll))
                        })
                    ]
                })
            ]
        });
    }
    renderUnassignedTable() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.table),
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    className: "text--h5 mt-0",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.metersUnassignedToCountry))
                }),
                /*#__PURE__*/ _jsx(Table, {
                    idKey: "deviceId",
                    schema: this.unassignedSchema,
                    entities: this.filteredUnassignedEntities,
                    perPage: 10,
                    isPerPageOff: true
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            onReset: ()=>this.onReset(),
            children: [
                this.renderSearch(),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.tables,
                    children: [
                        this.renderAssignedTable(),
                        this.renderUnassignedTable()
                    ]
                }),
                /*#__PURE__*/ _jsx(StandardActions, {
                    hasChanges: this.state.hasUnsavedChanges,
                    isInProgress: this.props.isFetchInProgress || this.props.isUpdateInProgress,
                    infoMessage: this.props.isConfiguredCountryActive ? messages.infos.saveOnActiveCountry : null
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            formInitialState: JSON.parse(JSON.stringify({
                assignedMeters: this.props.assignedMeters,
                unassignedMeters: this.props.unassignedMeters
            })),
            hasUnsavedChanges: false,
            assignedMeters: [
                ...this.props.assignedMeters
            ] || [],
            unassignedMeters: [
                ...this.props.unassignedMeters
            ] || [],
            shouldReset: false,
            isSearchProcessing: false
        };
        this.validatorRules = validatorRules;
    }
}
_define_property(MetersForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    isFetchInProgress: PropTypes.bool.isRequired,
    // Explicit actions
    onClose: PropTypes.func,
    // Implicit props
    isUpdateInProgress: PropTypes.bool.isRequired,
    configurationMeters: PropTypes.object
}));
const mapStateToProps = (state)=>{
    const assignedMeters = [];
    const unassignedMeters = [];
    const countryDevicesSKU = selectors.devices(state);
    const allDevices = App.selectors.devices(state);
    forEach(allDevices, (device)=>{
        if (countryDevicesSKU.includes(device.sku)) {
            assignedMeters.push(device);
        } else {
            unassignedMeters.push(device);
        }
    });
    return {
        formValues: App.selectors.formSelector(constants.CONFIGURE_COUNTRY_METERS_TAB_FORM)(state),
        isUpdateInProgress: selectors.isUpdateCountryConfigurationMetersInProgress(state),
        isConfiguredCountryActive: selectors.isConfiguredCountryActive(state),
        assignedMeters,
        unassignedMeters
    };
};
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.CONFIGURE_COUNTRY_METERS_TAB_FORM;
    return {
        onSubmit: (values)=>dispatch(actions.updateCountryConfigurationMeters(values)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedMetersForm = connect(mapStateToProps, mapDispatchToProps)(MetersForm);
export default withStyles(styles)(ConnectedMetersForm);
